import { useLocation } from 'react-router-dom';

/**
 * Returns the signup link with the current location search.
 */
export const useSignupLink = () => {
  const location = useLocation();

  // Note: location.search includes the leading `?` character.
  return `/signup${location.search}`;
};
